import { Tab as MuiTab, type TabProps as MuiTabProps } from '@mui/material'
import { hasOwnProperty } from '../../helpers'
import { Chip, type ChipProps } from '../../primitives/Chip'
import { type BaseProps } from '../../types'

export type TabProps<V = string> = Pick<MuiTabProps, 'value' | 'wrapped' | 'disabled' | 'icon'> &
  BaseProps<HTMLDivElement> & {
    value: V
    label: React.ReactNode
    chipValue?: ChipProps['label']
  }

/**
 * Tab
 *
 * Demos:
 * - [Tab](https://design-system.accept.cl1.intra.dhlparcel.io/?path=/docs/constructs-tab--docs)
 *
 */

export const Tab = <V = string,>({ chipValue, icon, ...props }: TabProps<V>) => {
  /**
   * props are decorated by MuiTabs, one the decorated props is `selected`
   * since we do not want to expose this prop on the MuiTab props, a small deviated is added for its determination
   */
  const isSelected = hasOwnProperty(props, 'selected') && props.selected === true
  return (
    <MuiTab
      title={props.value}
      {...{ 'aria-label': props.value }}
      {...props}
      {...(chipValue
        ? {
            icon: (
              <Chip label={chipValue} size="small" color={isSelected ? 'dark' : 'default'} disabled={props.disabled} />
            ),
            iconPosition: 'end',
          }
        : { icon })}
    />
  )
}
